var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKey = function SvgKey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.0001 8L76.0001 16M45.5601 46.44L62.0001 30M62.0001 30L74.0001 42L88.0001 28L76.0001 16M62.0001 30L76.0001 16M45.5601 46.44C47.6255 48.4779 49.2673 50.9042 50.3911 53.5792C51.5149 56.2542 52.0985 59.1251 52.1082 62.0265C52.118 64.928 51.5536 67.8027 50.4478 70.4852C49.3419 73.1677 47.7164 75.6049 45.6647 77.6566C43.613 79.7082 41.1758 81.3338 38.4933 82.4397C35.8109 83.5455 32.9361 84.1098 30.0347 84.1001C27.1332 84.0904 24.2623 83.5068 21.5873 82.383C18.9123 81.2592 16.486 79.6174 14.4481 77.552C10.4406 73.4028 8.22317 67.8455 8.27329 62.0772C8.32342 56.3088 10.6371 50.791 14.7161 46.712C18.7951 42.633 24.313 40.3193 30.0813 40.2692C35.8496 40.219 41.4069 42.4365 45.5561 46.444L45.5601 46.44Z",
    stroke: "black",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgKey;